import React from "react"
import classnames from "classnames"
import styles from "./CompetitionForm.less"
import gtmHandler from "AtomicUtils/gtmHandler"
import {
  InputSelect,
  FormGroup,
  InputText,
  InputEmail,
  InputCheckBox,
  Button,
  Space,
  ColumnGroup,
  Container,
  A,
  H3,
  H5,
  P,
  InputRadio,
  InputCaptcha
} from "AtomicComponents"
import {
  HeroContent,
  AlertList,
  Image,
  InputSearchable
} from 'AtomicContainers'
import componentParser from "AtomicUtils/componentParser"
import fetchAPI from "AtomicUtils/fetchAPI"
import { fromLinkInputs, formLinkSubmit, formSetValidations } from "AtomicUtils/formHandler"
import MESSAGES from "AtomicConstants/MESSAGES"
import TITLES from "./TITLES"

class CompetitionForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      form: {
        title: {
          validations: {
            required: MESSAGES.TITLE_REQUIRED
          }
        },
        firstName: {
          validations: {
            required: MESSAGES.FIRSTNAME_REQUIRED
          }
        },
        lastName: {
          validations: {
            required: MESSAGES.LASTNAME_REQUIRED
          }
        },
        phone: {
          validations: {
            required: MESSAGES.PHONE_NUMBER_REQUIRED,
            phone: MESSAGES.PHONE_NUMBER_INVALID
          }
        },
        email: {
          validations: {
            required: MESSAGES.EMAIL_REQUIRED,
            email: MESSAGES.EMAIL_INVALID
          }
        },
        region: {
          validations: {
            required: MESSAGES.LOCATION_REQUIRED,
            postcodeSearchable: MESSAGES.LOCATION_INVALID
          }
        },
        optedInDealer: {
          validations: {
            required: MESSAGES.OPTIN_REQUIRED
          }
        },
        bodyStyle: {
          validations: {
          }
        },
        privacy: {
          validations: {
            required: MESSAGES.PRIVACY_POLICY_REQUIRED
          }
        },
        reCaptcha: {
          validations: {
            required: MESSAGES.RECAPTCHA_REQUIRED
          }
        },
        submitButton: { disabled: true }
      },
      success: false,
      errorMessage: null
    }
  }

  _handleOptInChange = () => {
    const { bodyStyles } = this.props
    const { form } = this.state

    if (form.optedInDealer.value === "Yes" && bodyStyles && bodyStyles.length) {
      formSetValidations(this, "bodyStyle", { required: MESSAGES.BODYSTYLE_REQUIRED })
    } else {
      formSetValidations(this, "bodyStyle", {})
    }

    if (form && form.optedInDealer && form.optedInDealer.value) {
      gtmHandler({
        pageCategory: "Competition Form",
        pageAction: `Competition Form - Selected "OPTIN" - "${form.optedInDealer.value.toUpperCase()}"`
      })
    }
  }

  _handleBodyStyleChange = () => {
    const { form } = this.state

    if (form && form.bodyStyle && form.bodyStyle.value) {
      gtmHandler({
        pageCategory: "Competition Form",
        pageAction: `Competition Form - Selected "BODYSTYLE" - "${form.bodyStyle.value.toUpperCase()}"`
      })
    }
  }

  _handleOnBlurSearchableRegion = () => {
    const { form } = this.state
    if (form && form.region && form.region.value && form.region.value.description) {
      gtmHandler({
        pageCategory: "Competition Form",
        pageAction: `Competition Form - Selected "POSTCODE/SUBURB" - "${form.region.value.description.toUpperCase()}"`
      })
    }
  }

  _handleSubmit = async (event) => {
    if (event) event.preventDefault()
    const { loading, form } = this.state
    const { submitFormEndpoint, title, nameplateTitle = '', buttonText = 'Keep me informed' } = this.props

    if (form.reCaptcha && form.reCaptcha.dirty && !form.reCaptcha.isValid && this.form && this.form.reCaptcha) {
      this.form.reCaptcha.resetRecaptcha()
      return
    }

    if (!loading && !form.submitButton.disabled) {
      await this.setState({
        loading: true
      }, async () => {
        const { form } = this.state
        let body = {
          nameplateTitle: nameplateTitle,
          title: form.title.value,
          firstName: form.firstName.value,
          lastName: form.lastName.value,
          mobile: form.phone.value,
          email: form.email.value,
          bodyStyle: form.bodyStyle.value || null,
          optedInDealer: form.optedInDealer.value === "Yes" ? true : false,
        }
        if (form.region.value) body.postcode = form.region.value.postcode
        if (form.region.value) body.state = form.region.value.state
        if (form.region.value) body.suburb = form.region.value.suburb
        await fetchAPI({
          method: "POST",
          url: submitFormEndpoint,
          body: body
        })
        .then(async (response) => {
          const json = await response.json()
          const { success, errorMsg, words } = json
          if (!success) {
            this.setState({
              errorMessage: errorMsg,
              words: (words && words.split(",")) || [],
              loading: false
            })
          } else {
            // successful
            this.setState({
              loading: false,
              success: true
            }, () => {
              gtmHandler({
                pageCategory: `Competition Form`,
                pageAction: `Competition Form - "${nameplateTitle}" - Clicked "${buttonText}" - Successfully submitted.`
              })
            })
          }
        })
        .catch((response) => {
          this.setState({
            errorMessage: response.message || `Failed with status ${response.status}`,
            words: (response.words && response.words.split(",")) || [],
            loading: false
          })
        })
      })
    }
  }

  render() {
    const {
      title,
      optInMessage,
      imageUrl,
      privacyPolicy,
      privacyPolicyLink,
      introText,
      bodyStyles,
      buttonText = 'Keep me informed',
      showRecaptcha = false,
      thankYouComponents
    } = this.props

    const { form, errorMessage, loading, success } = this.state

    if (success) {
      return componentParser(thankYouComponents)
    }

    return (
      <div className={classnames({
        [styles.RegisterInterest]: true }
      )}>
        <H3 withDetails>{title}</H3>
        <P>{introText}</P>
        <Container styleName={imageUrl ? "tablet-wide" : "mobile"}>
          <ColumnGroup>
            <Container styleName="mobile">
              <div className={classnames({
                [styles.CompetitionForm]: !imageUrl
              })}>
                <form method="POST" onSubmit={this._handleSubmit} noValidate>
                  <FormGroup>
                    <InputSelect
                      name="title"
                      label="Title"
                      options={TITLES}
                      {...fromLinkInputs(this, "title")}
                      onBlur={() => {
                        if (form.title.value) {
                          gtmHandler({
                            pageCategory: "Competition Form",
                            pageAction: `Competition Form Form - Selected \"TITLE\" - ${form.title.value.toUpperCase()}`
                          })
                        }
                      }}
                    />
                  </FormGroup>
                  <FormGroup>
                    <InputText
                      name="firstName"
                      label="First Name"
                      {...fromLinkInputs(this, "firstName")}
                      onBlur={() => {
                        gtmHandler({
                          pageCategory: "Competition Form",
                          pageAction: "Competition Form Form - Entered \"FIRSTNAME\""
                        })
                      }}
                    />
                  </FormGroup>
                  <FormGroup>
                    <InputText
                      name="lastName"
                      label="Last Name"
                      {...fromLinkInputs(this, "lastName")}
                      onBlur={() => {
                        gtmHandler({
                          pageCategory: "Competition Form",
                          pageAction: "Competition Form Form - Entered \"LASTNAME\""
                        })
                      }}
                    />
                  </FormGroup>
                  <FormGroup>
                    <InputText
                      name="phone"
                      label="Phone"
                      {...fromLinkInputs(this, "phone")}
                      onBlur={() => {
                        gtmHandler({
                          pageCategory: "Competition Form",
                          pageAction: "Competition Form Form - Entered \"PHONE\""
                        })
                      }}
                    />
                  </FormGroup>
                  <FormGroup>
                    <InputEmail
                      name="email"
                      label="Email"
                      {...fromLinkInputs(this, "email")}
                      onBlur={() => {
                        gtmHandler({
                          pageCategory: "Competition Form",
                          pageAction: "Competition Form Form - Entered \"EMAIL\""
                        })
                      }}
                    />
                  </FormGroup>
                  <FormGroup>
                    <InputSearchable
                      name="region"
                      type="postcode"
                      label="Postcode/Suburb"
                      {...fromLinkInputs(this, "region")}
                      onBlur={this._handleOnBlurSearchableRegion}
                    />
                  </FormGroup>
                  <FormGroup center>
                    <H5>
                      Register your interest
                    </H5>
                  </FormGroup>
                  <FormGroup>
                    <p className={classnames({
                      [styles.CompetitionFormText]: true
                    })}>
                      {optInMessage || "Would you like to receive more information about the next-Gen Mazda3 via email? Please note, Mazda or Mazda Dealers may contact you in the future."}
                      <span className={classnames({
                        [styles.requiredStar]: true
                      })}>*</span>
                    </p>
                    <InputRadio
                      name="optedInDealer"
                      value={"Yes"}
                      label="Yes, I'd like to be contacted."
                      {...fromLinkInputs(this, "optedInDealer", this._handleOptInChange)}
                    />
                    <InputRadio
                      name="optedInDealer"
                      value={"No"}
                      label="No, I'd just like to enter the competition."
                      {...fromLinkInputs(this, "optedInDealer", this._handleOptInChange)}
                    />
                  </FormGroup>
                  <FormGroup
                    hide
                    show={form.optedInDealer.value === "Yes" && bodyStyles && bodyStyles.length}
                    >
                    <p className={classnames({
                      [styles.CompetitionFormText]: true
                    })}>
                      <b>Tell us which body style interests you the most</b>
                      <span className={classnames({
                        [styles.requiredStar]: true
                      })}>*</span>
                    </p>
                    {
                      bodyStyles &&
                      bodyStyles.length &&
                      bodyStyles.map(bodyStyle => {
                        return (
                          <InputRadio
                            name="bodyStyle"
                            key={bodyStyle.value}
                            value={bodyStyle.value}
                            label={bodyStyle.name}
                            {...fromLinkInputs(this, "bodyStyle", this._handleBodyStyleChange)}
                          />
                        )
                      })
                    }
                    <Space />
                  </FormGroup>
                  <hr style={{ height: "1px", border: "0", borderTop: "1px solid #D5D5D5" }}  />
                  <Space />
                  <FormGroup show checkbox>
                    <InputCheckBox
                      name="privacy"
                      label={
                        <span>
                          {privacyPolicy}
                          <A
                            href={privacyPolicyLink}
                            external>
                              <nobr> Privacy Policy</nobr>
                          </A>
                        </span>
                      }
                      {...fromLinkInputs(this, "privacy")}
                    />
                  </FormGroup>
                  <Space />
                  <Space />
                  {
                    <InputCaptcha
                      name="reCaptcha"
                      formType={showRecaptcha ? "normal" : "invisible"}
                      {...fromLinkInputs(this, "reCaptcha")}
                    />
                  }

                  <FormGroup>
                    <AlertList data={errorMessage} />
                    <Button
                      styleName="black"
                      loading={loading}
                      fullWidth
                      {...formLinkSubmit(this, this._handleSubmit)}
                    >
                      {buttonText}
                    </Button>
                  </FormGroup>
                </form>
              </div>
            </Container>
            {
              imageUrl && <Image src={imageUrl} />
            }
          </ColumnGroup>
        </Container>
      </div>
    )
  }
}

export default CompetitionForm



// WEBPACK FOOTER //
// ./src/AtomicContainers/CompetitionForm/CompetitionForm.jsx